/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vault } from '../../models/vault';

export interface VaultGetVault$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetVault(http: HttpClient, rootUrl: string, params: VaultGetVault$Params, context?: HttpContext): Observable<StrictHttpResponse<Vault>> {
  const rb = new RequestBuilder(rootUrl, vaultGetVault.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vault>;
    })
  );
}

vaultGetVault.PATH = '/vault/{vaultId}';
